var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-orange request-button gtag-rfi-information-button",on:{"click":_vm.setProgramId}},[_vm._v("Request "+_vm._s(_vm.mobile ? 'Info' : 'Information'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }